export default {
  methods: {
    copyToClipboard: function(text) {
      navigator.clipboard.writeText(text)
    }
  }
}
